"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmployeeStatusFilters () {
        return EmployeeStatusFilters;
    },
    get EmployeeStatusFiltersEnum () {
        return EmployeeStatusFiltersEnum;
    },
    get FieldCategory () {
        return FieldCategory;
    },
    get FieldType () {
        return FieldType;
    },
    get FieldTypeEnum () {
        return FieldTypeEnum;
    },
    get FilterComparison () {
        return FilterComparison;
    },
    get FilterComparisonEnum () {
        return FilterComparisonEnum;
    },
    get QuickFilterType () {
        return QuickFilterType;
    },
    get ReportingAggregationOperationTypes () {
        return ReportingAggregationOperationTypes;
    },
    get ReportingAggregationOperationTypesEnum () {
        return ReportingAggregationOperationTypesEnum;
    },
    get ReportingType () {
        return ReportingType;
    },
    get ReviewCycleStatusFilters () {
        return ReviewCycleStatusFilters;
    },
    get ReviewCycleStatusFiltersEnum () {
        return ReviewCycleStatusFiltersEnum;
    },
    get ReviewReportStatusFilters () {
        return ReviewReportStatusFilters;
    },
    get ReviewReportStatusFiltersEnum () {
        return ReviewReportStatusFiltersEnum;
    },
    get ReviewStatusFilters () {
        return ReviewStatusFilters;
    },
    get ReviewStatusFiltersEnum () {
        return ReviewStatusFiltersEnum;
    },
    get SUPPORTED_FILTER_COMPARISONS_BY_FIELD_TYPE () {
        return SUPPORTED_FILTER_COMPARISONS_BY_FIELD_TYPE;
    },
    get SummarizeByRowTypes () {
        return SummarizeByRowTypes;
    },
    get SummarizeByRowTypesEnum () {
        return SummarizeByRowTypesEnum;
    },
    get SummaryFunction () {
        return SummaryFunction;
    },
    get SummaryFunctionEnum () {
        return SummaryFunctionEnum;
    },
    get getSupportedFilterComparisons () {
        return getSupportedFilterComparisons;
    },
    get isArrayFilterValueSupported () {
        return isArrayFilterValueSupported;
    },
    get isSupportedFilterComparison () {
        return isSupportedFilterComparison;
    }
});
const _zod = require("zod");
var FilterComparison = /*#__PURE__*/ function(FilterComparison) {
    FilterComparison["Equals"] = "eq";
    FilterComparison["Between"] = "between";
    FilterComparison["GreaterThan"] = "gt";
    FilterComparison["GreaterThanOrEqual"] = "gte";
    FilterComparison["LessThan"] = "lt";
    FilterComparison["After"] = "after";
    FilterComparison["Before"] = "before";
    FilterComparison["LessThanOrEqual"] = "lte";
    FilterComparison["NotEqual"] = "ne";
    FilterComparison["Contains"] = "contains";
    FilterComparison["NotContains"] = "notcontains";
    FilterComparison["StartsWith"] = "startswith";
    FilterComparison["NotStartsWith"] = "notstartswith";
    FilterComparison["EndsWith"] = "endswith";
    FilterComparison["NotEndsWith"] = "notendswith";
    FilterComparison["Null"] = "null";
    return FilterComparison;
}({});
const FilterComparisonEnum = _zod.z.enum(FilterComparison);
var FieldType = /*#__PURE__*/ function(FieldType) {
    FieldType["People"] = "people";
    FieldType["Person"] = "person";
    FieldType["Text"] = "text";
    FieldType["Email"] = "email";
    FieldType["Phone"] = "phone";
    FieldType["Date"] = "date";
    FieldType["MultiSelect"] = "multi-select";
    FieldType["Numeric"] = "numeric";
    FieldType["SingleSelect"] = "single-select";
    FieldType["Monetary"] = "monetary";
    FieldType["Salary"] = "salary";
    FieldType["Textbox"] = "textbox";
    // eslint-disable-next-line id-blacklist
    FieldType["Boolean"] = "boolean";
    FieldType["Template"] = "template";
    FieldType["Department"] = "department";
    FieldType["Role"] = "role";
    FieldType["Cycle"] = "cycle";
    FieldType["Review"] = "review";
    FieldType["Status"] = "status";
    FieldType["Subject"] = "subject";
    FieldType["reviewReportStatus"] = "reviewReportStatus";
    FieldType["EmployeeStatus"] = "employeeStatus";
    FieldType["GoalStatus"] = "goalStatus";
    FieldType["GoalTransparency"] = "goalTransparency";
    FieldType["GoalOutlook"] = "goalOutlook";
    FieldType["GoalCategories"] = "goalCategories";
    FieldType["GoalAssignee"] = "goalAssignee";
    FieldType["GoalAlignment"] = "goal";
    FieldType["ResponseStatus"] = "responseStatus";
    FieldType["SurveyName"] = "surveyName";
    FieldType["Search"] = "search";
    return FieldType;
}({});
const FieldTypeEnum = _zod.z.enum(FieldType);
// FieldType -> allowed FilterComparison[] ("all" = comparison-agnostic). Mirrors webserver/assets/
// react/pages/ReportAnalytics/components/QueryBuilder/Config.ts fieldTypeOptionsLookup; outside
// this set selectMatchOperation (packages/utils-backend/.../select-match-operation.ts) returns
// null and the predicate is silently dropped instead of applied.
const EQUALS_ONLY = [
    "eq",
    "ne"
];
const TEXT_COMPARISONS = [
    "eq",
    "ne",
    "contains",
    "notcontains",
    "startswith",
    "notstartswith",
    "endswith",
    "notendswith"
];
const CONTAINS_COMPARISONS = [
    "eq",
    "ne",
    "contains",
    "notcontains"
];
const NUMERIC_COMPARISONS = [
    "eq",
    "ne",
    "gt",
    "gte",
    "lt",
    "lte"
];
const SUPPORTED_FILTER_COMPARISONS_BY_FIELD_TYPE = {
    ["text"]: TEXT_COMPARISONS,
    ["textbox"]: TEXT_COMPARISONS,
    ["email"]: CONTAINS_COMPARISONS,
    ["phone"]: CONTAINS_COMPARISONS,
    ["multi-select"]: CONTAINS_COMPARISONS,
    ["people"]: [
        "contains",
        "notcontains"
    ],
    // Full makeMongoDateComparison switch: eq/between collapse to a start–end range; before/lt,
    // after/gt, lte, gte all have explicit cases.
    ["date"]: [
        "eq",
        "between",
        "before",
        "after",
        "gt",
        "gte",
        "lt",
        "lte"
    ],
    ["numeric"]: NUMERIC_COMPARISONS,
    ["monetary"]: NUMERIC_COMPARISONS,
    ["salary"]: NUMERIC_COMPARISONS,
    ["person"]: EQUALS_ONLY,
    ["single-select"]: EQUALS_ONLY,
    ["boolean"]: EQUALS_ONLY,
    ["template"]: EQUALS_ONLY,
    ["department"]: EQUALS_ONLY,
    ["cycle"]: EQUALS_ONLY,
    ["status"]: EQUALS_ONLY,
    ["goal"]: EQUALS_ONLY,
    ["goalCategories"]: EQUALS_ONLY,
    ["goalOutlook"]: EQUALS_ONLY,
    ["goalTransparency"]: EQUALS_ONLY,
    ["role"]: EQUALS_ONLY,
    // Not in Config.ts's lookup; every existing caller only ever constructs these with Equals.
    ["review"]: EQUALS_ONLY,
    ["subject"]: EQUALS_ONLY,
    ["reviewReportStatus"]: EQUALS_ONLY,
    ["employeeStatus"]: EQUALS_ONLY,
    ["goalStatus"]: EQUALS_ONLY,
    ["goalAssignee"]: EQUALS_ONLY,
    ["responseStatus"]: EQUALS_ONLY,
    ["surveyName"]: EQUALS_ONLY,
    // Search's match is a separate $or-across-columns branch that never reads comparison.
    ["search"]: "all"
};
const getSupportedFilterComparisons = (type)=>SUPPORTED_FILTER_COMPARISONS_BY_FIELD_TYPE[type];
const isSupportedFilterComparison = (type, comparison)=>{
    const supported = getSupportedFilterComparisons(type);
    return supported === "all" || supported.includes(comparison);
};
// Types makeMongoArrayComparison (select-match-operation.ts) delegates to compareManySubjectFields
// for, restricted to the comparisons that function actually implements (Equals/NotEqual/Contains/
// NotContains) -- its switch's `default` returns null for anything else.
const ARRAY_CAPABLE_SUBJECT_TYPES = [
    "people",
    "multi-select",
    "department",
    "subject"
];
const SUBJECT_ARRAY_COMPARISONS = [
    "eq",
    "ne",
    "contains",
    "notcontains"
];
// makeMongoArrayComparison's third branch: person/cycle/template only build a $in/$nin from an
// array for Contains/NotContains -- every other comparison falls through to its `return null`.
const ARRAY_CAPABLE_CONTAINS_TYPES = [
    "person",
    "cycle",
    "template"
];
const isArrayFilterValueSupported = (type, comparison)=>{
    // date is handled in its own branch before makeMongoArrayComparison and accepts a 1- or
    // 2-element array for every comparison the type itself supports (see the Date entry in
    // SUPPORTED_FILTER_COMPARISONS_BY_FIELD_TYPE above -- it already mirrors makeMongoDateComparison's
    // full switch).
    if (type === "date") {
        return isSupportedFilterComparison("date", comparison);
    }
    if (ARRAY_CAPABLE_SUBJECT_TYPES.includes(type)) {
        return SUBJECT_ARRAY_COMPARISONS.includes(comparison);
    }
    if (type === "numeric") {
        return comparison === "between";
    }
    if (ARRAY_CAPABLE_CONTAINS_TYPES.includes(type)) {
        return comparison === "contains" || comparison === "notcontains";
    }
    return false;
};
const FieldCategory = _zod.z.enum([
    "GOAL_FIELD",
    "EMPLOYEE_FIELD",
    "REVIEW_FIELD",
    "REVIEW_CYCLE_FIELD",
    "REVIEW_FORM_FIELD",
    "REVIEW_REPORT_FIELD",
    "GROUPED_QUESTION",
    "SUBJECT",
    "SURVEY_FIELD"
]);
const ReportingType = _zod.z.enum([
    "employeeReport",
    "reviewReport",
    "employee",
    "goalReport",
    "surveyReport"
]);
const QuickFilterType = _zod.z.enum([
    "allReviews",
    "startedBetween",
    "completedBetween",
    "reviewReportStatus",
    "reviewStatus",
    "department",
    "reviewCycleNames",
    "reviewFormNames"
]);
var SummarizeByRowTypes = /*#__PURE__*/ function(SummarizeByRowTypes) {
    SummarizeByRowTypes["GOAL"] = "GOAL_FIELD";
    SummarizeByRowTypes["EMPLOYEE"] = "EMPLOYEE_FIELD";
    SummarizeByRowTypes["REVIEW_CYCLE"] = "REVIEW_CYCLE_FIELD";
    SummarizeByRowTypes["REVIEW_FIELD"] = "REVIEW_FIELD";
    SummarizeByRowTypes["REVIEW_FORM_FIELD"] = "REVIEW_FORM_FIELD";
    SummarizeByRowTypes["UNIQUE_QUESTION"] = "UNIQUE_QUESTION";
    SummarizeByRowTypes["SURVEY"] = "SURVEY_FIELD";
    return SummarizeByRowTypes;
}({});
const SummarizeByRowTypesEnum = _zod.z.enum(SummarizeByRowTypes);
var SummaryFunction = /*#__PURE__*/ function(SummaryFunction) {
    SummaryFunction["Average"] = "average";
    SummaryFunction["Sum"] = "sum";
    SummaryFunction["Minimum"] = "minimum";
    SummaryFunction["Maximum"] = "maximum";
    SummaryFunction["Count"] = "count";
    SummaryFunction["Concatenate"] = "concatenate";
    SummaryFunction["MissingSummaryFunction"] = "none";
    return SummaryFunction;
}({});
const SummaryFunctionEnum = _zod.z.enum(SummaryFunction);
var ReportingAggregationOperationTypes = /*#__PURE__*/ function(ReportingAggregationOperationTypes) {
    ReportingAggregationOperationTypes["EMPLOYEE"] = "EMPLOYEE_FIELD";
    ReportingAggregationOperationTypes["REVIEW_CYCLE"] = "REVIEW_CYCLE_FIELD";
    ReportingAggregationOperationTypes["REVIEW_FIELD"] = "REVIEW_FIELD";
    ReportingAggregationOperationTypes["REVIEW_FORM_FIELD"] = "REVIEW_FORM_FIELD";
    ReportingAggregationOperationTypes["UNIQUE_QUESTION"] = "UNIQUE_QUESTION";
    return ReportingAggregationOperationTypes;
}({});
const ReportingAggregationOperationTypesEnum = _zod.z.enum(ReportingAggregationOperationTypes);
var ReviewStatusFilters = /*#__PURE__*/ function(ReviewStatusFilters) {
    ReviewStatusFilters["Completed"] = "Completed";
    ReviewStatusFilters["Active"] = "Active";
    ReviewStatusFilters["Scheduled"] = "Scheduled";
    return ReviewStatusFilters;
}({});
const ReviewStatusFiltersEnum = _zod.z.enum(ReviewStatusFilters);
var ReviewCycleStatusFilters = /*#__PURE__*/ function(ReviewCycleStatusFilters) {
    ReviewCycleStatusFilters["Completed"] = "completed";
    ReviewCycleStatusFilters["Active"] = "active";
    ReviewCycleStatusFilters["Scheduled"] = "scheduled";
    return ReviewCycleStatusFilters;
}({});
var EmployeeStatusFilters = /*#__PURE__*/ function(EmployeeStatusFilters) {
    EmployeeStatusFilters["Active"] = "Active";
    EmployeeStatusFilters["Deactivated"] = "Deactivated";
    return EmployeeStatusFilters;
}({});
const EmployeeStatusFiltersEnum = _zod.z.enum(EmployeeStatusFilters);
const ReviewCycleStatusFiltersEnum = _zod.z.enum(ReviewCycleStatusFilters);
var ReviewReportStatusFilters = /*#__PURE__*/ function(ReviewReportStatusFilters) {
    ReviewReportStatusFilters["Completed"] = "completed";
    ReviewReportStatusFilters["Deleted"] = "deleted";
    ReviewReportStatusFilters["InProgress"] = "in-progress";
    ReviewReportStatusFilters["InProgressAwaitingSubmission"] = "in-progress-awaiting-authors";
    ReviewReportStatusFilters["InProgressAwaitingSignOff"] = "in-progress-awaiting-signoff";
    ReviewReportStatusFilters["NotStarted"] = "not-started";
    return ReviewReportStatusFilters;
}({});
const ReviewReportStatusFiltersEnum = _zod.z.enum(ReviewReportStatusFilters);
